"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
// eslint-disable-next-line react-hooks/exhaustive-deps
var useOnce = function (effect) { return react_1.useEffect(effect, []); };
exports.default = useOnce;
